export default "__VITE_ASSET__QxGi06v6__ 100w";